import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as base64_decode, encode as base64_encode } from 'base-64';

const RestRastroNfePost = (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();

  const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
  const storage = JSON.parse(usersRt);
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  switch (caminho) {
    case 'pesqLotes':
      return new Promise(function (resolve, reject) {
        const { dataPost } = JSON.parse(config.data);
        try {
          const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
          $.ajax({
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('rastroNfe'),
              ll: base64_encode('pesqLotes'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, _status, _xhr) {
              data = JSON.parse(base64_decode(data));
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              const reqUrl = `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`;
              const httpStatus = xhr && typeof xhr.status === 'number' && xhr.status > 0 ? xhr.status : 503;
              const statusText = (xhr && (xhr.statusText || xhr.responseText)) || '';

              resolve([
                httpStatus,
                {
                  message: 'Serviço indisponível',
                  details: `Falha ao conectar em ${reqUrl}. status=${String(status || '')} error=${String(error || '')} ${statusText ? `resp=${String(statusText).slice(0, 500)}` : ''}`,
                  code: 'NETWORK_ERROR',
                },
              ]);
            },
          });
        } catch (err) {
          resolve([
            500,
            {
              message: 'Serviço indisponível',
              details: `Erro ao preparar requisição: ${String(err || '')}`,
              code: 'NETWORK_ERROR',
            },
          ]);
        }
      });

    default:
      return new Promise(function (resolve, _reject) {
        resolve([400, { message: 'Destino inválido' }]);
      });
  }
};

const RestRastroNfeGet = (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();

  const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
  const storage = JSON.parse(usersRt);
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  switch (caminho) {
    default:
      return new Promise(function (resolve, _reject) {
        resolve([400, { message: 'Destino inválido' }]);
      });
  }
};

export { RestRastroNfePost, RestRastroNfeGet };
